export default "__VITE_PUBLIC_ASSET__e59ba88a__"